<div
  class="sl-modal-header-container"
  [ngStyle]="{ 'align-items': getAlignment() }"
>
  @if(backButton || infoIcon) {
  <div class="sl-modal-header-back">
    @if(backButton) {
    <sl-button
      type="icon-only"
      iconName="arrow_back"
      size="small"
      variant="tertiary"
      (clickEvent)="onClickBack()"
    ></sl-button>
    } @if(infoIcon) {
    <span class="material-symbols-outlined info-icon"> info </span>
    }
  </div>
  }
  <div class="sl-modal-header-info">
    <p class="sl-modal-header-title">{{ title }}</p>
    @if(subtitle) {
    <p class="sl-modal-header-subtitle">Subtitle</p>
    }
  </div>
  <div class="sl-modal-header-actions">
    @if(closeButton){
    <sl-button
      type="icon-only"
      iconName="close"
      size="small"
      variant="tertiary"
      (clickEvent)="onClickClose()"
    ></sl-button>
    }
  </div>
</div>
